module.exports = __webpack_public_path__ + "img/image_grow_mic.c5c9b0e8.png";